// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch-input_switch__2FTGp","text":"switch-input_text__2MyZh","textChecked":"switch-input_textChecked__1kTCy","textDisabled":"switch-input_textDisabled__1Alfp"};